import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const netdata = defineConnector({
  identifier: "netdata",
  name: "Netdata",
  tagLine: "Infrastructure monitoring",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://app\\.netdata\\.cloud/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Netdata Cloud](https://app.netdata.cloud/), go to your **User Settings › API Tokens** and create a new token. See the [API docs](https://learn.netdata.cloud/docs/netdata-cloud/) for details.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.netdata.cloud/api/v2/spaces",
  },
});
